<div class="text-center" *ngIf="documents == null">
    <span>
        <i class="fa-solid fa-spinner fa-spin"></i>
    </span>
</div>

<div *ngIf="documents != null" class="d-flex flex-column gap-2">
    <app-know-how-document-category-list [categories]="documents.categories"
        [sportName]="'know-how.documents.generally' | transloco">
    </app-know-how-document-category-list>
    <ng-container *ngFor="let sport of documents.sports">
        <app-know-how-document-category-list [categories]="sport.categories" [sportName]="sport.name">
        </app-know-how-document-category-list>
    </ng-container>
</div>